module.exports = __webpack_public_path__ + "media/images/lb/646-f0d902f85ca7059edec56f1b7a03a5e7.svg";